
import { Fragment } from "react";
import { Box } from "@chakra-ui/react";
import ServiceArrivalRatesTable, {
  renderOrganizationArrivalRatesPerServiceCell,
} from "../../organization/ServiceArrivalRatesTable";
import { useSelector } from "react-redux";
import * as defaultSelectors from "../../../store/selectors/defaultSelector";
import ConfiguredReportTable from "../../reports/ConfiguredReportTable";
import ArrivalRatesPerServiceSummary from "../../branches/reports/ArrivalRatesPerServiceSummary";
import {
  ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
  sortReportRows,
} from "../../../store/renderConfig";
import { buildArrivalRatesPerServiceInsights } from "../../../store/arrivalRatesPerServiceInsights";


const ArrivalRatesByService = ({ reportIndex, data }) => {
  const renderConfig = useSelector(defaultSelectors.selectRenderConfig);
  const servicesData = Array.isArray(data) ? data : [];
  const organization = {
    branchName: "Entire Organization",
    organizationTotalArrivals: servicesData.reduce((sum, service) => sum + Number(service.total || 0), 0),
    servicesData,
  };
  const insights = buildArrivalRatesPerServiceInsights(organization);
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
  });
  const rows = config.charts.enabled
    ? insights.topChartServices
    : sortReportRows(insights.rankedServices, config, {
      columnDefinitions: ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS,
      });

  if (!config.charts.enabled) {
    return (
      <Box className="reportTableContainer arrivalRatesPerServiceUnifiedBlock">
        <ArrivalRatesPerServiceSummary branch={organization} />
        <ConfiguredReportTable
          columns={ARRIVAL_RATES_PER_SERVICE_COLUMN_DEFINITIONS}
          rows={rows}
          renderConfig={config}
          renderCell={renderOrganizationArrivalRatesPerServiceCell}
        />
      </Box>
    );
  }

  return (
    <>
      <ArrivalRatesPerServiceSummary branch={organization} />
      <h3>Top Service Trend Detail</h3>
      {rows.map((serviceData, index) => {
        return (
          <Fragment key={`${reportIndex}-${index}`}>
            <ServiceArrivalRatesTable
              index={index}
              reportIndex={reportIndex}
              serviceData={serviceData}
              renderConfig={config}
            />
          </Fragment>
        );
      })}
    </>
  );
};

export default ArrivalRatesByService;
